import { Component, OnInit } from '@angular/core';
import { Products } from 'src/app/model/products.model';
import { ProductService } from 'src/app/services/product/product.service';
import { Productcategory } from 'src/app/model/productcategory.model';
import { OrderService } from 'src/app/services/order/order.service';
import { Router, ActivatedRoute } from '@angular/router';
import { isNullOrUndefined } from 'util';


@Component({
  selector: 'app-editorder',
  templateUrl: './editorder.component.html',
  styleUrls: ['./editorder.component.css']
})
export class EditorderComponent implements OnInit {

  //product: Products;
  category: Productcategory;
  cartItems: any;
  orderNo: string;
  totalPrice: any;



  constructor(private productServices: ProductService, private route: ActivatedRoute, private router: Router, private orderServices: OrderService) {
    // this.productServices.getProductCategory().subscribe(
    //   (data: any) => {
    //     this.category = data;
    //     console.log(this.category);
    //   }
    // )
    this.orderNo = this.route.snapshot.params.ordernumber;
    //alert(this.orderNo);
  }

  ngOnInit() {
    // this.productServices.getProductList().subscribe(
    //   (data: any) => {
    //     this.product = data;
    //     console.log(this.product);
    //   }
    // )
    this.getCartItems();
  }

  addtocart(productId: number) {
    this.orderServices.addToCart(productId).subscribe(
      (data: any) => {
        if (data == true) {
          //alert("added");
          this.getCartItems();
        }
        else {
          alert("already added");
        }
      }
    )
  }

  onQuantityChange(quantity: number) {
    //console.log(quantity);
    //alert(quantity);
    if (quantity < 0) {
      alert("quantity can't be less than 1");
    }
    else {
      this.totalPrice = 0.0;
      for (var i = 0; i < this.cartItems.length; i++) {
        var unitprice = this.cartItems[i].unitCost;
        var itemprice = this.cartItems[i].quantity * unitprice;
        //pricenum = pricenum.replace('$','');
        //var pricenumfloat = parseFloat(pricenum); 
        this.totalPrice = this.totalPrice + itemprice;
        this.totalPrice = Math.round(this.totalPrice * 100) / 100;
      }
    }
  }

  getCartItems() {
    this.totalPrice = 0.0;
    this.orderServices.getOrderItemForEdit(this.orderNo).subscribe(
      (data: any) => {
        this.cartItems = data;
        console.log(this.cartItems);
        if (!isNullOrUndefined(this.cartItems)) {
          for (var i = 0; i < this.cartItems.length; i++) {
            // var pricenum = this.cartItems[i].unitCost;
            // pricenum = pricenum.replace('$', '');
            // var pricenumfloat = parseFloat(pricenum);
            // this.totalPrice = this.totalPrice + pricenumfloat;
            var unitprice = this.cartItems[i].unitCost;
            var itemprice = this.cartItems[i].quantity * unitprice;
            //pricenum = pricenum.replace('$','');
            //var pricenumfloat = parseFloat(pricenum); 
            this.totalPrice = this.totalPrice + itemprice;
            this.totalPrice = Math.round(this.totalPrice * 100) / 100;
          }
        }
      }
    )
  }

  removefromcart(cartId: number) {
    //alert(cartId);
    this.orderServices.removeFromOrder(cartId).subscribe(
      (data: any) => {
        if (data == true) {
          //alert("added");
          this.getCartItems();
        }
        else {
          alert("already removed");
        }
      }
    )
  }

  placeOrder() {
    //this.router.navigate(['/confirmorder']);
    //console.log(this.cartItems);
    if (this.totalPrice < 1) {
      alert("quantity can't be less than 1");
    }
    else {
      this.orderServices.updateorder(this.cartItems).subscribe(
        (data: any) => {
          if (data != null) {
            this.router.navigate(['/confirmorder', data.ordrNumber]);
            //alert("Order Placed");
          }
          console.log(data);
        }
      )
    }

  }

}
